var map = {
	"./logo_230x55.jpg": 94777,
	"./logo_230x55.png": 22642,
	"./logo_50x50.png": 81774,
	"./logo_55x55.jpg": 84100,
	"./screw32_32.png": 15515,
	"./sfondo01.jpg": 31137,
	"./sfondo01_spareparts.jpg": 59150,
	"./sfondo02opt.jpg": 86545,
	"./webtreats_metal_4-512px.jpg": 25948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56522;